import React, { useState } from "react";
import {
  Bell,
  PersonCircle,
  Gear,
  BoxArrowRight,
  Search,
} from "react-bootstrap-icons";
import "../css/Header.css";
import logo from "../img/ff.png";

const Header = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
const handleLogout = () => {
  // Remove stored login/session data
  localStorage.clear();
  sessionStorage.clear();

  // Optional: If you store a specific token:
  // localStorage.removeItem("authToken");

  // Redirect to login page
  window.location.href = "https://auxititpt.org/login";
};

  return (
    <header className="header shadow-sm px-4 py-2 bg-white d-flex align-items-center justify-content-between">
      {/* Left side: Logo + Title */}
      {/* <div className="d-flex align-items-center gap-3">
        <img src={logo} alt="Logo" className="header-logo" />
        <h5 className="m-0 fw-semibold text-primary">Auxilium ITI Dashboard</h5>
      </div> */}

      {/* Middle: Search box */}
      <div className="search-bar position-relative">
        {/* <Search className="search-icon" />
        <input
          type="text"
          className="form-control ps-5 search-input"
          placeholder="Search here..."
        /> */}
      </div>

      {/* Right side: Icons + Profile */}
      <div className="d-flex align-items-center gap-4">
        <div className="notification position-relative">
          {/* <Bell className="fs-4 text-primary" /> */}
          <span className="badge bg-danger position-absolute top-0 start-100 translate-middle p-1 rounded-circle"></span>
        </div>

        {/* Profile dropdown */}
        <div className="profile-section position-relative">
          <div
            className="d-flex align-items-center gap-2 profile-toggle"
            onClick={() => setDropdownOpen(!isDropdownOpen)}
          >
            <PersonCircle className="fs-3 text-secondary" />
            <span className="fw-semibold text-dark">Admin</span>
          </div>

          {isDropdownOpen && (
            <div className="profile-dropdown shadow">
              <ul className="list-unstyled m-0">
                {/* <li>
                  <a href="#" className="dropdown-item">
                    <PersonCircle /> Profile
                  </a>
                </li>
                <li>
                  <a href="#" className="dropdown-item">
                    <Gear /> Settings
                  </a>
                </li> */}
                <li>
                <a className="dropdown-item logout" onClick={handleLogout}>
  <BoxArrowRight /> Logout
</a>

                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
